import script from "./EventTypesModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./EventTypesModal.vue?vue&type=script&setup=true&lang=ts"

import "./EventTypesModal.vue?vue&type=style&index=0&id=1d6de77f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1d6de77f"]])

export default __exports__